<template>
  <div>
    <Head :title="form.name" />
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><Link href="/settings">Settings</Link></li>
        <li class="breadcrumb-item"><Link href="/settings/operators">Operators</Link></li>
        <li class="breadcrumb-item active" aria-current="page">{{ form.name }}</li>
      </ol>
    </nav>
    <h1>
      {{ form.name }}
    </h1>
    <trashed-message v-if="operators.deleted_at" class="mb-6" @restore="restore"> This operator has been deleted. </trashed-message>
    <div class="content-box">
      <form @submit.prevent="update">
        <OperatorForm :form="form" :types="types" />

        <div class="actions-toolbar d-flex justify-content-between">
          <button v-if="!operators.deleted_at" class="btn btn-outline-danger" tabindex="-1" type="button" @click="destroy">Delete Operator</button>
          <loading-button :loading="form.processing" class="btn btn-primary" type="submit">Update Operator</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import OperatorForm from './components/OperatorForm'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  components: {
    Head,
    Icon,
    Link,
    OperatorForm,
    LoadingButton,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    operators: Object,
    types: Object
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: this.operators.name,
        code: this.operators.code,
        contact_name: this.operators.contact_name,
        contact_email: this.operators.contact_email,
        contact_phone: this.operators.contact_phone,
        comment: this.operators.comment,
        types: this.operators.types.map((m) => m.id)
      }),
    }
  },
  methods: {
    hasType(value) {
      return  this.form.types.some(
        ({ id }) => id === value
      )
    },
    update() {
      this.form.put(`/settings/operators/${this.operators.id}`)
    },
    destroy() {
      if (confirm('Are you sure you want to delete this operator?')) {
        this.$inertia.delete(`/settings/operators/${this.operators.id}`)
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this operator?')) {
        this.$inertia.put(`/settings/operators/${this.operators.id}/restore`)
      }
    },
  },
}
</script>
